import { createSlice } from "@reduxjs/toolkit"

const testsSlice = createSlice({
  name: "tests",
  initialState: {
    activeTests: [],
    testHistory: [],
    selectedTest: null,
    testTemplates: [],
    testResults: null,
    loading: false,
    error: null,
  },
  reducers: {
    setActiveTests: (state, action) => {
      state.activeTests = action.payload;
    },
    setTestHistory: (state, action) => {
      state.testHistory = action.payload;
    },
    setSelectedTest: (state, action) => {
      state.selectedTest = action.payload;
    },
    setTestTemplates: (state, action) => {
      state.testTemplates = action.payload;
    },
    setTestResults: (state, action) => {
      state.testResults = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearTestState: (state) => {
      state.selectedTest = null;
      state.testResults = null;
      state.error = null;
    }
  },
})

export const { 
  setActiveTests,
  setTestHistory,
  setSelectedTest,
  setTestTemplates,
  setTestResults,
  setLoading,
  setError,
  clearTestState
} = testsSlice.actions

export default testsSlice.reducer 